module.exports = __webpack_public_path__ + "img/9stars.9aa3d079.jpg";